import { ACTIONS_TYPES } from "../utils/constants";




export function fetchMetersRequest() {
  return {
    type: ACTIONS_TYPES.FETCH_METERS_REQUEST,
  }
}

export function fetchMetersSuccess(response) {
  return {
    type: ACTIONS_TYPES.FETCH_METERS_SUCCESS,
    payload: response,
  }
}

export function fetchMetersFailed(error) {
  return {
    type: ACTIONS_TYPES.FETCH_METERS_FAILED,
    payload: error,
  }
}

export function fetchMetersReset() {
  return {
    type: ACTIONS_TYPES.FETCH_METERS_RESET,
  }
}

export function registerMeterRequest(payload) {
  return {
    type: ACTIONS_TYPES.REGISTER_METER_REQUEST,
    payload
  }
}

export function registerMeterSuccess(response) {
  return {
    type: ACTIONS_TYPES.REGISTER_METER_SUCCESS,
    payload: response,
  }
}

export function registerMeterFailed(response) {
  return {
    type: ACTIONS_TYPES.REGISTER_METER_FAILED,
    payload: response,
  }
}

export function registerMeterReset() {
  return {
    type: ACTIONS_TYPES.REGISTER_METER_RESET,
  }
}


